// extracted by mini-css-extract-plugin
module.exports = {"latest-list":"styles-m__latest-list__cJ-sO","li-list":"styles-m__li-list__3r70X","ul-grid":"styles-m__ul-grid__2NyWX","footer-title":"styles-m__footer-title__16txH"};